import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventAdSubscriptionPriceOptionClickedMapper extends Mapper {
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper

    this._config = config

    this._TRACKING_EVENT_HIT_INFORMATIONS = this._config.get('tracking').HIT_INFORMATIONS

    this._SUBSCRIPTION_AD_CONTEXT = this._config.get('search').SUBSCRIPTION_AD_CONTEXT
  }

  setParams({context, pageName}) {
    this._context = context
    this._pageName = pageName
    return this
  }

  map({event}) {
    let hitInformation
    switch (this._context) {
      case this._SUBSCRIPTION_AD_CONTEXT.COMMITMENT:
        hitInformation = this._TRACKING_EVENT_HIT_INFORMATIONS.SUBSCRIPTION_AD_COMMITMENT_CLICKED
        break
      case this._SUBSCRIPTION_AD_CONTEXT.ALLOWANCE:
        hitInformation = this._TRACKING_EVENT_HIT_INFORMATIONS.SUBSCRIPTION_AD_KM_INCLUDED_CLICKED
        break
    }

    return {
      event,
      data: {
        hit_information: hitInformation
      }
    }
  }
}
